import React from 'react';
import { DisplayInputComponentProps } from '../../types';
import type { FieldValues } from 'react-hook-form';
import { commonComponentsRegistry } from '../../../registry/CommonRegistry';

export const InputEmail = <TFieldValues extends FieldValues>(props: DisplayInputComponentProps<TFieldValues>) => {
    const JRCInputEmail = commonComponentsRegistry.getLazyComponent('InputEmail');
    return (
        <JRCInputEmail
            {...props}
            placeholder={props.placeholder}
            htmlFor={`displayer-field-${props.name}`}
            rules={{ required: props.mandatory }}
            margin={props.margin}
        />
    );
};
